import React from 'react'
import Home from './components/Home/Home'
import Projects from './components/Projects/Projects'
import './App.css'

function App() {
    return (
        <div className="app">
            <Home />
            <Projects />
        </div>
    )
}

export default App
